import { Link } from "react-router-dom";
import { genres } from "@/mocks/comics";

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=wide%20romantic%20anime%20illustration%20of%20a%20young%20couple%20silhouetted%20under%20a%20blooming%20cherry%20tree%20at%20golden%20dusk%2C%20falling%20petals%20drifting%20in%20the%20air%2C%20soft%20warm%20peach%20and%20coral%20sky%2C%20dreamy%20bokeh%20lights%2C%20cinematic%20wide%20composition%2C%20clean%20anime%20style%2C%20gentle%20glowing%20atmosphere%2C%20romantic%20and%20heartfelt%20mood&width=1600&height=900&seq=hero-home-2026&orientation=landscape"
        alt="羞羞动漫漫画恋爱后宫题材背景图"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/40 via-background-950/30 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <p className="text-background-50 text-sm md:text-base tracking-[0.3em] uppercase font-calligraphy text-accent-200">
          恋爱 · 后宫 · 暧昧 · 同居 · 校园 · 逆后宫
        </p>
        <h1 className="mt-4 font-heading font-black text-4xl md:text-6xl text-background-50 leading-tight">
          羞羞动漫漫画
        </h1>
        <p className="mt-4 text-background-100 md:text-lg leading-relaxed max-w-2xl mx-auto">
          恋爱与后宫题材漫画追更专区，汇集暧昧、同居、校园、逆后宫等热门作品。分类清晰，更新及时，追更不迷路。
        </p>

        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category"
            className="whitespace-nowrap px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            进入分类专区
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/#ranking"
            className="whitespace-nowrap px-7 py-3 rounded-full border border-background-50/70 text-background-50 text-sm font-semibold hover:bg-background-50/10 transition-colors"
          >
            查看人气榜单
          </Link>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {genres.map((g) => (
            <Link
              key={g.id}
              to={`/category?genre=${g.id}`}
              className="whitespace-nowrap px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs border border-background-50/25 hover:bg-primary-500/80 transition-colors"
            >
              {g.name}番
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}